import React from 'react';
//import logo from './logo.svg';
import './App.css';

import { Route, Switch, Router } from 'react-router-dom';

import ForgotPassword from './components/recovery/forgotpassword';
import Recoverusername from './components/recovery/recoverusername';

import Signup from './components/signup/signup';
import Resetpassword from './components/recovery/resetpassword';
import Login from './components/login/login';
import SupportLogin from './components/login/supportLogin';
import Instance from './components/server/instance/instance';
import CreateInstance from './components/server/createInstance/createInstance';

import SshKey from './components/sshKey/sshkey';
import FirewallCreate from './components/firewall/firewallcreate';
import Firewall from './components/firewall/firewall';
import FirewallNew from './components/firewall/firewallNew';
import Server from './components/server/server';
import Images from './components/images/images';
import User from './components/users/users';
import Error from './components/error/error';
import SettingsMain from './components/settings/settingsMain';
import PrivateRoute from './components/privateroute/privateroute';
import Webactivitylogs from './components/usersection/webactivitylogs';
import Account from './components/account/account';
import VolumesMain from './components/volumes/volumesMain';
import Expired from './components/error/expired';
import { createBrowserHistory } from 'history';
import Invoice from './components/account/invoice';
import $ from 'jquery';
import Passwordexpired from './components/error/passwordexpire';
import { Signupnew } from './components/signup/signupnew';
import SubAccountNew from './components/signup/subaccountnew';
import { Emailverification } from './components/signup/emailverification';
import TestUser from './components/common/testUser';
import Partnerlogin from './components/partnerpages/partnerlogin';
import Partnerindex from './components/partnerpages/partnerindex';
import Promo from './components/signup/promo';
import Emailverify from './components/common/emailverify';
import cloneInstance from './components/server/createInstance/cloneInstance';

import Partnerroute from './components/privateroute/partnerroute';
import PartnerPassword from './components/partnerpages/partnerrestpassword';
import Partnerexpired from './components/partnerpages/partnerexpire';
import PartnerCreate from './components/partnerpages/partnercreate';
import CloneStatus from './components/common/cloneStatus';
import SubUsertwoFaLoginConfigure from './components/twofa/subUsertwoFaLoginConfigure';
import TwoFaVerification from './components/twofa/twoFaVerification';
import TwoFaOtpDeactivate from './components/twofa/twoFatOtpDeactivate';
import Twofaroute from './components/privateroute/twofaroute';
import { PrintRecovery } from './components/account/printRecovery';
import BareMetalIndex from './components/baremetal/barmetalindex';
import ReverseDnsDashboard from './components/reverseDns/reversednsdashboard';
import BareMetalPromo from './components/baremetal/baremetalpromo';
import CreateLoadBal from './components/loadbalancers/createloadbalancer';
import ManageLoadBal from './components/loadbalancers/manageloadbalancer';

import Dummy from './components/dummy/dummy';
import InstanceNew from './components/server/instance/instanceNew';
import Billing from './components/account/billing';
import ConsoleError from './components/error/consoleerror';
import ListLoadBalancerMain from './components/loadbalancers/listloadbalancers';
import Referral from './components/referral/referral';
import signupRedirect from './components/signup/signupRedirect';
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
  }
  componentDidMount() {
    localStorage.removeItem('progressBarPerc');
    $(document).keyup(function (e) {
      if(localStorage.getItem('isImageUpload')) {
        return;
      }
      if(e.keyCode === 27) {
        $('.main_slider, .main_popup').removeClass('active');   // esc
        $('body').removeClass('no_scroll');

      }
    });
    // this simulates an async action, after which the component will render the content
    asyncCall().then(() => this.setState({ loading: false }));
  }
  render() {
    const loading = this.state.loading;
    const history = createBrowserHistory({ basename: '/app' });
    if(loading) { // if your component doesn't have to wait for an async action, remove this block 
      return null; // render null when app is not ready
    }
    return (
      <div className="App menu_update">
        <Router history={ history } >
          <Switch>
            <Route exact path='/bounty-partner/login' component={ Partnerlogin }></Route>
            <Route exact path='/dummy' component={ Dummy }></Route>
            <Partnerroute exact path='/bounty-partner/index' component={ Partnerindex }></Partnerroute>
            <Route exact path='/bounty-partner/password-expired' component={ Partnerexpired }></Route>
            <Route exact path='/bounty-partner/create-partner' component={ PartnerCreate }></Route>
            <Route exact path='/' component={ Login } i18n={ this.props.i18n }></Route>
            <Route exact path="/login" render={ props => <Login { ...props } i18n={ this.props.i18n } /> }></Route>
            <Route exact path="/login/oauth2/code/github" render={ props => <Login { ...props } i18n={ this.props.i18n } /> }></Route>
            <Route exact path="/login/support/:email" component={ SupportLogin }></Route>
            <Route exact path='/expired' component={ Expired }></Route>
            <Route exact path='/console-error' component={ ConsoleError }></Route>
            <Route exact path='/emailverify' component={ Emailverify }></Route>
            <Route exact path='/password-expired' component={ Passwordexpired }></Route>
            <Route exact path='/signup/v2' component={ Signupnew }></Route>
            <Route exact path='/signup' component={ signupRedirect }></Route>
            <Route exact path='/promo/:company' component={ signupRedirect }></Route>
            <Route exact path='/promo/bare/:company' component={ signupRedirect }></Route>
            <Route exact path="/sub-account/:token" component={ SubAccountNew }></Route>
            <Route exact path='/recover-username' component={ Recoverusername }></Route>
            <Route exact path='/forgot-password' component={ ForgotPassword }></Route>
            <Route exact path='/email-confirmation' component={ Emailverification }></Route>
            <Route exact path='/bmrService-report' component={ BareMetalIndex }></Route>
            <Route exact path='/rDNSService-report' component={ ReverseDnsDashboard }></Route>
            <Route exact path='/bounty-partner/update-password/:username/:token' component={ PartnerPassword }></Route>
            <Route exact path='/update-password/:username/:token' component={ Resetpassword }></Route>
            <PrivateRoute exact path="/web-activity" component={ Webactivitylogs } i18n={ this.props.i18n }></PrivateRoute>
            <PrivateRoute exact path='/index' component={ InstanceNew } i18n={ this.props.i18n }></PrivateRoute>
            <PrivateRoute exact path='/create' component={ CreateInstance } i18n={ this.props.i18n }></PrivateRoute>
            <PrivateRoute exact path="/firewall-edit" component={ FirewallCreate } i18n={ this.props.i18n }></PrivateRoute>
            <PrivateRoute exact path="/firewall" component={ FirewallNew } i18n={ this.props.i18n }></PrivateRoute>
            <PrivateRoute exact path="/ssh-key" component={ SshKey } i18n={ this.props.i18n }></PrivateRoute>
            <PrivateRoute path="/server/:sub" component={ Server } i18n={ this.props.i18n }></PrivateRoute>
            <PrivateRoute exact path="/images" component={ Images } i18n={ this.props.i18n }></PrivateRoute>
            <PrivateRoute exact path="/users" component={ User } i18n={ this.props.i18n }></PrivateRoute>
            <PrivateRoute exact path="/settings-main" component={ SettingsMain } i18n={ this.props.i18n }></PrivateRoute>
            <PrivateRoute path="/account/:sub" component={ Account } i18n={ this.props.i18n }></PrivateRoute>
            <PrivateRoute path="/billing/:sub" component={ Billing } i18n={ this.props.i18n }></PrivateRoute>
            <PrivateRoute path="/referral/:sub" component={ Referral } i18n={ this.props.i18n }></PrivateRoute>
            <PrivateRoute exact path="/volumes" component={ VolumesMain } i18n={ this.props.i18n }></PrivateRoute>
            <PrivateRoute path="/invoice/:invoiceId" component={ Invoice } i18n={ this.props.i18n }></PrivateRoute>
            <PrivateRoute path="/print-recovery/:userId" component={ PrintRecovery } i18n={ this.props.i18n }></PrivateRoute>
            <Twofaroute path="/print-recovery-login/:userId" component={ PrintRecovery } i18n={ this.props.i18n }></Twofaroute>
            <PrivateRoute path="/instance-clone" component={ cloneInstance } i18n={ this.props.i18n }></PrivateRoute>
            <Route path="/test-user" component={ TestUser }></Route>
            <Twofaroute path="/2fa-configure" component={ SubUsertwoFaLoginConfigure }></Twofaroute>
            <Twofaroute path="/2fa-verification" component={ TwoFaVerification }></Twofaroute>
            <Twofaroute path="/2fa-deactivate" component={ TwoFaOtpDeactivate }></Twofaroute>
            <PrivateRoute exact path="/create-loadbalancer" component={ CreateLoadBal } i18n={ this.props.i18n }></PrivateRoute>
            <PrivateRoute exact path="/manage-loadbalancer" component={ ManageLoadBal } i18n={ this.props.i18n }></PrivateRoute>
            <PrivateRoute exact path="/load-balancers" component={ ListLoadBalancerMain } i18n={ this.props.i18n }></PrivateRoute>
            {/* <PrivateRoute  path = "/clone-status" component = {CloneStatus} ></PrivateRoute> */ }

            <Route component={ Error }></Route>
            <Route path="/error" component={ Error }></Route>

          </Switch>
        </Router>
      </div>
    );
  }

}
function asyncCall() {
  return new Promise((resolve) => setTimeout(() => resolve(), 100));
}
export default App;
